import Image1 from "../image/sauna/image1.webp";
import Image2 from "../image/sauna/image2.webp";
import Image3 from "../image/sauna/image3.webp";
import Image4 from "../image/sauna/image4.webp";

export const SaunaData = [
  {
    id: 1,
    image: Image1,
    alt: "Image sauna 1",
  },
  {
    id: 2,
    image: Image2,
    alt: "Image sauna 2",
  },
  {
    id: 3,
    image: Image3,
    alt: "Image sauna 3",
  },
  {
    id: 4,
    image: Image4,
    alt: "Image sauna 4",
  },
];
